import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITeamMember, ITeamMemberInitialState } from "./teamMemberModal";
import {
  ActiveInactiveTeamMember,
  TeamMemberImageUpload,
  createTeamMember,
  deleteTeamMember,
  getAllActiveTeamMembers,
  getAllTeamMembers,
  getTeamMemberByID,
  updateTeamMember,
} from "./services/teamMember.services";

const initialState: ITeamMemberInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  TeamMemberID: null,
  TeamMemberList: [],
  TeamMemberDetail: {
    Name: "",
    Title: "",
    Email: "",
    Image: "",
    Message: "",
    PhoneNo: "",
    Whatsapp: "",
    Linkedin: "",
    Skype: "",
    IsActive: 1,
  },
};

const teamMemberSlice = createSlice({
  name: "teammember",
  initialState,
  reducers: {
    clearTeamMemberDetails: (state) => {
      state.TeamMemberDetail = initialState.TeamMemberDetail;
    },
    setTeamMemberID: (state, action) => {
      state.TeamMemberID = action.payload;
    },
    clearTeamMemberID: (state) => {
      state.TeamMemberID = initialState.TeamMemberID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTeamMembers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllTeamMembers.fulfilled,
      (state, action: PayloadAction<ITeamMember[]>) => {
        state.loading = false;
        state.TeamMemberList = action.payload || [];
      }
    );
    builder.addCase(getAllTeamMembers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TeamMemberList = [];
    });
    builder.addCase(createTeamMember.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createTeamMember.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createTeamMember.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTeamMember.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(updateTeamMember.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateTeamMember.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTeamMember.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTeamMemberByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getTeamMemberByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.TeamMemberDetail = action.payload;
    });
    builder.addCase(getTeamMemberByID.rejected, (state, action) => {
      state.formLoading = false;
      state.TeamMemberDetail = initialState.TeamMemberDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveTeamMembers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveTeamMembers.fulfilled,
      (state, action: PayloadAction<ITeamMember[]>) => {
        state.loading = false;
        state.TeamMemberList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveTeamMembers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TeamMemberList = [];
    });
    builder.addCase(ActiveInactiveTeamMember.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveTeamMember.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveTeamMember.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(TeamMemberImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(TeamMemberImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(TeamMemberImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearTeamMemberDetails, clearTeamMemberID, setTeamMemberID } =
  teamMemberSlice.actions;
export default teamMemberSlice.reducer;
